import type { ResumoDaOs } from '../../../types/ordemDeServico'
import { dataSimples } from '../../../lib/datas'
import { OS } from '../textosDaOs'

/** O que a tabela e o cartão anunciam ao leitor de tela. */
export const DESCRICAO_DA_LISTA = 'Ordens de serviço registradas, da mais recente para a mais antiga'

/** As colunas da tabela, na ordem em que aparecem. */
export const COLUNAS = [
  { id: 'numero', titulo: OS.numeroDoSistema, classe: '' },
  { id: 'regime', titulo: 'Modelo', classe: 'hidden lg:table-cell' },
  { id: 'competencia', titulo: OS.competencia, classe: '' },
  { id: 'periodo', titulo: OS.periodo, classe: 'hidden md:table-cell' },
  { id: 'emitida', titulo: OS.emitidaEm, classe: 'hidden lg:table-cell' },
  { id: 'situacao', titulo: OS.situacao, classe: '' },
  { id: 'valor', titulo: OS.valor, classe: 'text-right' },
] as const

/**
 * O período da ordem, escrito como o documento o escreve.
 *
 * **`dataSimples` nas duas pontas, nunca `data`.** `periodoInicio` e `periodoFim` chegam como
 * `AAAA-MM-DD` sem hora; `new Date('2026-05-06')` é meia-noite em UTC e volta 05/05/2026 no fuso de
 * Niterói. Um dia a menos aqui é um dia a menos no período que a ordem autorizou.
 *
 * @param ordem a linha da listagem
 * @returns o período em `dd/MM/aaaa a dd/MM/aaaa`
 */
export function periodoDaOs(ordem: Pick<ResumoDaOs, 'periodoInicio' | 'periodoFim'>): string {
  return `${dataSimples(ordem.periodoInicio)} a ${dataSimples(ordem.periodoFim)}`
}

/**
 * O mês da ordem, ou a razão de não haver mês.
 *
 * A ordem de projeto (ANEXO IA) atravessa meses e por isso **não tem** competência — o traço aqui
 * não é dado faltando, é a diferença entre os dois modelos do contrato. Escrever o mês da emissão
 * no lugar a faria entrar na apuração de um mês que ela não cobre.
 *
 * @param ordem a linha da listagem
 * @returns o mês no formato do documento, ou o traço
 */
export function mesDaOs(ordem: Pick<ResumoDaOs, 'competencia'>): string {
  return ordem.competencia ?? '—'
}
